import { formatCurrency } from "@vinyl/shared";
import type { WorldView } from "../render/world-view.js";
import { AnchoredOverlay } from "./anchored-overlay.js";

export interface GoldFloaterSpawn {
  amount: number; // copper
  anchorId: string;
}

export class GoldFloater {
  private readonly overlay: AnchoredOverlay<GoldFloaterSpawn>;

  constructor(layer: HTMLElement, worldView: WorldView) {
    this.overlay = new AnchoredOverlay({
      layer,
      worldView,
      durationMs: 1400,
      fadeBeforeMs: 500,
      // Sits 28 px below the XP floater (yOffset -44 vs -16) so the two
      // don't overlap when a kill grants both at the same tick.
      yOffset: -16,
      riseProgressPx: 36,
      createNode: ({ amount }) => {
        if (amount <= 0) return null;
        const node = document.createElement("div");
        node.className = "gold-float";
        node.textContent = `+${formatCurrency(amount)}`;
        return node;
      },
    });
  }

  spawn(spawn: GoldFloaterSpawn, now = performance.now()): void {
    this.overlay.spawn(spawn.anchorId, spawn, now);
  }

  destroy(): void {
    this.overlay.destroy();
  }
}
